var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M5.9 19.485L14.385 11 5.9 2.515a1 1 0 0 1 0-1.415 1 1 0 0 1 1.414 0l9.193 9.193a1 1 0 0 1 0 1.414l-9.193 9.192a1 1 0 0 1-1.414 0 1 1 0 0 1 0-1.414z"}})}
var staticRenderFns = []

export { render, staticRenderFns }